module.exports = __webpack_public_path__ + "static/media/submenu-painel.4bd8b714.svg";